import wrapper from 'wrapper';
import Paper from './components/paper/paper';

Paper(wrapper);
wrapper.markPageAsLoaded();
